import { getAds } from '@/api/ads';
import { IAdsData } from '@/api/ads/interfaces';
import { useEffect, useState } from 'react';

interface LivescoreAdsProps {
  prefetchedAds?: IAdsData;
}

const LinvescoreAds = ({ prefetchedAds }: LivescoreAdsProps) => {
  const [ads, setAds] = useState<IAdsData | null>(prefetchedAds ?? null);

  useEffect(() => {
    if (ads) return;
    void getAds(['Livescore']).then((data) => setAds(data));
  }, []);

  return (
    <ul className="list-none px-0">
      {ads?.data
        .sort((a, b) => a.attributes.order - b.attributes.order)
        .map(({ id, attributes }) => (
          <li className="flex justify-center sm:justify-start" key={id}>
            <a href={attributes.destinationUrl}>
              <picture>
                <source media="(min-width: 980px)" srcSet={attributes.desktopImage.data.attributes.url} />
                <img
                  alt={attributes.mobileImage.data.attributes.alternativeText}
                  src={attributes.mobileImage.data.attributes.url}
                />
              </picture>
            </a>
          </li>
        ))}
    </ul>
  );
};

export default LinvescoreAds;
